import _ from 'lodash'
import ObjectEmployee from 'utils/objects/employee'
import { MODE_SCAN_IN, MODE_SCAN_OUT } from 'utils/constants/qrcode-constants'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import HelperDate, { dateFormat } from 'utils/helper-date'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import useDatetime from 'utils/hooks/use-datetime'
import { useEffect, useState } from 'react'

export const SCAN_STATUS = {
	NOT_SCANNED_IN: 'is_not_scanned_in',
	SCANNED_IN: 'is_scanned_in',
	SCANNED_OUT: 'is_scanned_out',
}

export const getScanningEnabled = () => {
	const isScanningInEnabled = HelperSetting.isYes( settingsConstants.SCAN_IN_ENABLED );
	const isScanningOutEnabled = HelperSetting.isYes( settingsConstants.SCAN_OUT_ENABLED );
	const isScanningEnabled = isScanningInEnabled || isScanningOutEnabled;
	
	return {
		isScanningInEnabled,
		isScanningOutEnabled,
		isScanningEnabled,
	}
}

export const getEmployeeScanStatus = ( _employee, datetime ) => {
	const { isScanningInEnabled, isScanningOutEnabled, isScanningEnabled } = getScanningEnabled()
	
	let scanStatus = SCAN_STATUS.NOT_SCANNED_IN;
	let isScannedIn = false;
	let scanInDate = null;
	let scanInBuilding = null;
	let scanInThrough = null;
	let isScannedOut = false;
	let scanOutThrough = null;
	
	const employeeScans = _.filter( ObjectEmployee.getScans( _employee ), o => {
		return HelperDate.date( o.scanned_in_at ).format( dateFormat.DATE ) === HelperDate.date( datetime ).format( dateFormat.DATE );
	});
	
	_.forEach( employeeScans, ( employeeScan ) => {
		switch( employeeScan.status ) {
			case 'scanned_in':
				isScannedIn = true;
				scanInDate = employeeScan.scanned_in_at;
				scanInThrough = employeeScan.scanned_in_through;
				scanInBuilding = employeeScan.building
				break;
			
			case 'scanned_out':
				isScannedOut = true;
				scanOutThrough = employeeScan.scanned_out_through;
				break;
		}
	});
	
	switch( true ) {
		// Only set to scanned in if someone is actually scanned in
		case isScannedIn:
			scanStatus = SCAN_STATUS.SCANNED_IN;
			break;
		
		// Only set to checked out if someone actually scanned out and is not scanned in anymore
		case isScannedOut:
			scanStatus = SCAN_STATUS.SCANNED_OUT;
			break;
	}
	
	
	// Get the scan mode
	let scanMode = null
	if( isScanningEnabled ) {
		scanMode = MODE_SCAN_IN
		
		if( isScanningOutEnabled ) {
			scanMode = (scanStatus === SCAN_STATUS.SCANNED_IN )? MODE_SCAN_OUT : MODE_SCAN_IN
		}
	}
	
	return {
		isScanningInEnabled,
		isScanningOutEnabled,
		isScanningEnabled,
		scanStatus,
		scanInDate,
		scanInThrough,
		scanInBuilding,
		scanMode,
		scanOutThrough
	}
}

export const useEmployeeScanStatus = () => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const datetime = useDatetime();
	
	const [ result, setResult ] = useState( getEmployeeScanStatus( _employee, datetime ) )
	
	const process = () => {
		setResult( getEmployeeScanStatus( _employee, datetime ) )
	}
	
	useEffect( () => {
		process();
	}, [ _employee, datetime ] );
	
	return result
}
